import TextAndImageSection from "../../componets/TextAndImageSection";

export default function Section6() {
  return (
    <TextAndImageSection
      sectionName="Section6"
      containerName="section6"
      containerStyle="md:p-[2%_5px_0px_5px] mt-[4%] mb-[3%]"
      title="Experience the Transformation"
      text="Join hands with Mean3 to experience the transformational power of Staff Augmentation. Let us assist you in increasing productivity, accelerating implementation cycles, and empowering development for businesses and organizations through the use of our staff augmentation services, industry knowledge, and technical capabilities."
      imgUrl="assets/mean3-image-staff-aug.webp"
      dividerMargin="mt-[1%] md:mt-[5%]"
    />
  );
}
